var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.dialogVisible,
        title: _vm.editorType + "商品",
        "before-close": _vm.close,
        width: "600px",
        "custom-class": "inventory-goods-editor",
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _c(
        "div",
        { staticClass: "p16" },
        [
          _c(
            "el-form",
            {
              ref: "editorFormRef",
              attrs: {
                rules: _vm.formRules,
                model: _vm.formData,
                "label-width": "100px",
                size: "medium",
              },
              nativeOn: {
                submit: function ($event) {
                  $event.preventDefault()
                },
                keydown: function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  ) {
                    return null
                  }
                  $event.preventDefault()
                },
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "商品品牌", prop: "brand" } },
                [
                  _c("el-input", {
                    staticClass: "form-input",
                    model: {
                      value: _vm.formData.brand,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "brand", $$v)
                      },
                      expression: "formData.brand",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "商品名称", prop: "name" } },
                [
                  _c("el-input", {
                    staticClass: "form-input",
                    model: {
                      value: _vm.formData.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "name", $$v)
                      },
                      expression: "formData.name",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "商品规格", prop: "spec" } },
                [
                  _c("el-input", {
                    staticClass: "form-input",
                    model: {
                      value: _vm.formData.spec,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "spec", $$v)
                      },
                      expression: "formData.spec",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "商品条码", prop: "barcode" } },
                [
                  _c("el-input", {
                    staticClass: "form-input",
                    attrs: { placeholder: "输入后按回车查询" },
                    nativeOn: {
                      keyup: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        return _vm.onGoodsScanQuery(_vm.formData.barcode)
                      },
                    },
                    model: {
                      value: _vm.formData.barcode,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "barcode", $$v)
                      },
                      expression: "formData.barcode",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "换算数量", prop: "convertQty" } },
                [
                  _c("el-input", {
                    staticClass: "form-input",
                    attrs: { type: "number" },
                    model: {
                      value: _vm.formData.convertQty,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "convertQty", $$v)
                      },
                      expression: "formData.convertQty",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "子商品" } },
                [
                  _c("el-autocomplete", {
                    staticClass: "form-input",
                    attrs: {
                      "fetch-suggestions": _vm.goodsSearchAsync,
                      placeholder: "请输入商品查询关键词",
                      "value-key": "name",
                      clearable: "",
                    },
                    on: {
                      select: _vm.onChildGoodsSelect,
                      clear: _vm.onChildGoodsClear,
                    },
                    model: {
                      value: _vm.childGoodsText,
                      callback: function ($$v) {
                        _vm.childGoodsText = $$v
                      },
                      expression: "childGoodsText",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "子商品条码", prop: "childBarcode" } },
                [
                  _c("el-input", {
                    staticClass: "form-input",
                    model: {
                      value: _vm.formData.childBarcode,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "childBarcode", $$v)
                      },
                      expression: "formData.childBarcode",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "状态", prop: "status" } },
                [
                  _c("el-switch", {
                    attrs: { "active-value": 1, "inactive-value": 0 },
                    model: {
                      value: _vm.formData.status,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "status", $$v)
                      },
                      expression: "formData.status",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "备注信息", prop: "remark" } },
                [
                  _c("el-input", {
                    attrs: { type: "textarea" },
                    model: {
                      value: _vm.formData.remark,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "remark", $$v)
                      },
                      expression: "formData.remark",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-row",
            { staticClass: "mb20", attrs: { type: "flex", justify: "end" } },
            [
              _c("el-button", { on: { click: _vm.close } }, [_vm._v("取消")]),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.onSubmit } },
                [_vm._v("提交")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }